"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconImageIndentLeft = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconImageIndentLeft = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5H21C21.5523 5 22 4.55228 22 4C22 3.44772 21.5523 3 21 3H3Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15 8.25C14.4477 8.25 14 8.69772 14 9.25C14 9.80228 14.4477 10.25 15 10.25H21C21.5523 10.25 22 9.80228 22 9.25C22 8.69772 21.5523 8.25 21 8.25H15Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14 14.75C14 14.1977 14.4477 13.75 15 13.75H21C21.5523 13.75 22 14.1977 22 14.75C22 15.3023 21.5523 15.75 21 15.75H15C14.4477 15.75 14 15.3023 14 14.75Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3 19C2.44772 19 2 19.4477 2 20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20C22 19.4477 21.5523 19 21 19H3Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.56811 7C4.31573 6.99997 4.06993 6.99994 3.86178 7.01695C3.63318 7.03563 3.36345 7.07969 3.09202 7.21799C2.7157 7.40974 2.40974 7.7157 2.21799 8.09202C2.07969 8.36345 2.03563 8.63318 2.01695 8.86178C1.99994 9.06993 1.99997 9.31572 2 9.56809L2 14.4319C1.99997 14.6843 1.99994 14.9301 2.01695 15.1382C2.03563 15.3668 2.07969 15.6366 2.21799 15.908C2.40974 16.2843 2.7157 16.5903 3.09202 16.782C3.36345 16.9203 3.63318 16.9644 3.86178 16.9831C4.06994 17.0001 4.31574 17 4.56812 17H9.43189C9.68428 17 9.93007 17.0001 10.1382 16.9831C10.3668 16.9644 10.6366 16.9203 10.908 16.782C11.2843 16.5903 11.5903 16.2843 11.782 15.908C11.9203 15.6366 11.9644 15.3668 11.9831 15.1382C12.0001 14.9301 12 14.6843 12 14.4319V9.56812C12 9.31574 12.0001 9.06994 11.9831 8.86178C11.9644 8.63318 11.9203 8.36345 11.782 8.09202C11.5903 7.7157 11.2843 7.40974 10.908 7.21799C10.6366 7.07969 10.3668 7.03563 10.1382 7.01695C9.93008 6.99994 9.68429 6.99997 9.43192 7H4.56811Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M21 9.25H15M21 4H3M21 14.75H15M21 20H3M4.6 16H9.4C9.96005 16 10.2401 16 10.454 15.891C10.6422 15.7951 10.7951 15.6422 10.891 15.454C11 15.2401 11 14.9601 11 14.4V9.6C11 9.03995 11 8.75992 10.891 8.54601C10.7951 8.35785 10.6422 8.20487 10.454 8.10899C10.2401 8 9.96005 8 9.4 8H4.6C4.03995 8 3.75992 8 3.54601 8.10899C3.35785 8.20487 3.20487 8.35785 3.10899 8.54601C3 8.75992 3 9.03995 3 9.6V14.4C3 14.9601 3 15.2401 3.10899 15.454C3.20487 15.6422 3.35785 15.7951 3.54601 15.891C3.75992 16 4.03995 16 4.6 16Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconImageIndentLeft = IconImageIndentLeft;
//# sourceMappingURL=IconImageIndentLeft.js.map